import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { I18nProvider } from './contexts/I18nContext';
import { PWAProvider } from './contexts/PWAContext';
import { TierProvider } from './components/TierGate';
import OfflineIndicator from './components/common/OfflineIndicator';
import PWAInstallPrompt from './components/common/PWAInstallPrompt';
import { UpdateBanner } from './components/pwa/PWAComponents';
// The phase-aware router (/app prefix, construction + handover + community trees).
// The sidebar has always linked to these paths; the app was still loading the old
// flat router, so every sidebar link 404'd.
import router from './routes/newRouter';

const App = () => {
  return (
    <ThemeProvider>
    <I18nProvider>
    <PWAProvider>
    <AuthProvider>
    <TierProvider>
      <RouterProvider router={router} />
      <OfflineIndicator />
      <PWAInstallPrompt />
      <UpdateBanner />
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            borderRadius: '8px',
            background: '#1B3A5C',
            color: '#fff',
            fontSize: '0.875rem',
          },
          success: {
            iconTheme: { primary: '#28A745', secondary: '#fff' },
          },
          error: {
            style: { background: '#DC3545' },
          },
        }}
      />
    </TierProvider>
    </AuthProvider>
    </PWAProvider>
    </I18nProvider>
    </ThemeProvider>
  );
};

export default App;
